export enum LanguageTypes {
  ENGLISH = "en",
  ITALIAN = "it",
  FRENCH = "fr",
  GERMAN = "de",
  SPANISH = "es",
  DUTCH = "nl",
}